import React, { useEffect, useState } from "react";
import { API } from "@/lib/api";

// Brand palette presets. Gold accents are unchanged; only the navy family (and CTA red
// for the crimson option) is swapped. Everything on the site reads these CSS variables.
export const THEMES = {
  navy: { label: "Classic Navy (current)", swatch: "#12386E", vars: {} },
  royal: {
    label: "Royal Blue #042898",
    swatch: "#042898",
    vars: { "--navy": "#042898", "--navy-ink": "#02185e", "--navy-mid": "#0a34b3", "--navy-lt": "#3a68e8" },
  },
  crimson: {
    label: "Crimson #E8151B",
    swatch: "#E8151B",
    vars: { "--navy": "#E8151B", "--navy-ink": "#8f0a0e", "--navy-mid": "#c11116", "--navy-lt": "#f0575b", "--red": "#a3070c" },
  },
};

export default function ThemeStyle() {
  const [theme, setTheme] = useState(
    () => new URLSearchParams(window.location.search).get("theme") || null
  );
  useEffect(() => {
    if (theme) return; // ?theme= preview overrides the saved value
    fetch(`${API}/settings`)
      .then((r) => r.json())
      .then((d) => setTheme(d.theme || "navy"))
      .catch(() => setTheme("navy"));
  }, [theme]);
  const vars = (THEMES[theme] || THEMES.navy).vars;
  const css = ":root{" + Object.entries(vars).map(([k, v]) => `${k}:${v}`).join(";") + "}";
  return <style data-testid="theme-style">{css}</style>;
}
